import vehicleMutations from './mutations.js';
import vehicleActions from './actions.js';
import vehicleGetters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            selectedvehicle: 0,
            selectedyear: 0,
            selectedmake: {},
            selectedmodel: {},
            selectedengine: {},
            selectedcategories: [],
            selectedgroups: [],
            selectedquestions: [],
            savedvehiclelist: [],
            newsavedvehicleadded: false,
            
            industry_sels: [],
            
            kit_vehicle: {
                year: null,
                make: null,
                engine: null,
                vin: null,

                year_desc: null,
                make_desc: null,
                eng_desc: null,
                vin_desc: null,
            },
        }
    },
    mutations: vehicleMutations,
    actions: vehicleActions,
    getters: vehicleGetters
};
